import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as notifications } from 'react-notification-system-redux';
import authReducer from '../reducers/auth';
import runtime from '../reducers/runtime';
import notificationReducer from "../routes/notification/modules/notification";

export const makeRootReducer = asyncReducers => combineReducers({
  auth: authReducer,
  form: formReducer,
  notifications,
  routing: routerReducer,
  runtime,
  notification: notificationReducer,
  ...asyncReducers,
});

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// src/store/reducers.js